/* @flow strict */

import * as React from 'react';
import HoverSplash from './hoverSplash';
import _ from 'lodash';

type PropsType = {
    p: {
      text: string,
      link_label: string,
      id: number
    }
  };

const Text = (props: PropsType): React.Element<'div'> => {
  const { p } = props;

  return (
    <div className={`splash-section ${p.background_color === 'Light' ? 'splash_section_light' : 'splash_section_dark'}`} id={`${_.toLower(p.link_label)}${p.id}`}>
    <div className="splash-container">
      <div dangerouslySetInnerHTML={{ __html: p.text }} />
      </div>
      <HoverSplash {...props} />
    </div>
  );
};

export default Text;
